import { ComponentType } from "react";

import Project8 from "./project8";
import Project0 from "./project0";
import Project1 from "./project1";
import Project2 from "./project2";
import Project3 from "./project3";
import Project4 from "./project4";
import Project6 from "./project6";
import Project7 from "./project7";

import CANDELA from "../../images/KTH_8.jpg";
import TEG from "../../images/TEGGallery.jpg";
import plant from "../../images/plantWateringGallery.jpg";
import timeline from "../../images/timelineGallery.png";
import container from "../../images/containerGallery.png";
import takbox from "../../images/takboxRosaGallery.jpg";
import trangiaNatur from "../../images/trangiaNaturGallery.jpg";
import stolen from "../../images/stolenGallery.png";

interface ProjectEntry {
  Component: ComponentType;
  photo: { src: string; width: number; height: number };
}

const projects: ProjectEntry[] = [
  { Component: Project8, photo: { src: CANDELA, width: 4416, height: 2947 } },
  { Component: Project0, photo: { src: TEG,     width: 4416, height: 2947 } },
  { Component: Project1, photo: { src: plant,   width: 900,  height: 675  } },
  { Component: Project2, photo: { src: timeline, width: 1920, height: 944 } },
  { Component: Project3, photo: { src: container, width: 662, height: 732 } },
  { Component: Project4, photo: { src: takbox,  width: 1280, height: 946  } },
  { Component: Project6, photo: { src: trangiaNatur, width: 1334, height: 890 } },
  { Component: Project7, photo: { src: stolen,  width: 774,  height: 760  } },
];

export default projects;
